export const esMessages = {
    "custom": {
        "teamEfficiency": "Eficiencia del equipo",
        "teamMembers": "Miembros del equipo",
        "dashboard": "Tablero",
        "planning": "Planificación",
        "info": "Informacion",
        "profile": "Perfil",
        "language": "Idioma",
        "trend": "Tendencia",
        "volume": "Volumen",
        "myTeam": "Mi equipo",
        "allTeams": "Todos los equipos",
        "teamCalendar": "Calendario del equipo",
        "saveChanges": "Guardar cambios",
        "cancel": "Cancelar",
        "warehouse": "Almacén De Café",
        "startFreeTrial": "Iniciar prueba gratuita",
        "buyNow": "Comprar ahora",
        "getSource": "Obtenga el código fuente en GitHub",
        "demoInfo": "Esta aplicación de demostración está construida utilizando los siguientes componentes de KendoReact y el tema predeterminado de KendoReact.",
        "firstName": "Primer nombre",
        "middleName": "Segundo nombre",
        "lastName": "Apellido",
        "email": "Dirección de correo electrónico",
        "phoneNumber": "Número de teléfono",
        "country": "País",
        "biography": "Biografía corta",
        "public": "Incluir en directorio público",
        "team": "Equipo",
        "employee": "Empleado",
        "contactName": "Nombre de contacto",
        "jobTitle": "Título del trabajo",
        "status": "Estado",
        "performance": "Rendimiento",
        "rating":"Clasificación",
        "engagement": "Compromiso",
        "budget": "Presupuesto",
        "contacts": "Contactos",
        "address": "Dirección",
        "phone": "Teléfono",
        "gridSearch": "Buscar en todas las columnas ...",
        "exportExcel": "Exportar a Excel",
        "exportPdf": "Exportar a PDF"
    },
    "datepicker": {
        "toggleCalendar": "Alternar calendario"
    },
    "calendar": {
        "today": "Hoy"
    },
    "dateinput": {
        "increment": "Incrementar valor",
        "decrement": "Disminuir valor"
    },
    "datetimepicker": {
        "date": "Fecha",
        "time": "Hora",
        "cancel": "Cancelar",
        "set": "Establecer"
    },
    "numerictextbox": {
        "increment": "Incrementar valor",
        "decrement": "Disminuir valor"
    },
    "timepicker": {
        "now": "AHORA",
        "set": "Establecer",
        "cancel": "Cancelar"
    },
    "grid": {
        "groupPanelEmpty": "Arrastre el título de una columna y suéltelo aquí para agrupar por ese criterio",
        "noRecords": "No hay datos disponibles.",
        "pagerFirstPage": "Ir a la primera página",
        "pagerPreviousPage": "Ir a la página anterior",
        "pagerNextPage": "Ir a la página siguiente",
        "pagerLastPage": "Ir a la última página",
        "pagerPage": "Página",
        "pagerOf": "de",
        "pagerItems": "ítems",
        "pagerInfo": "{0} - {1} de {2} ítems",
        "pagerItemsPerPage": "ítems por página",
        "filterEqOperator": "Es igual a",
        "filterNotEqOperator": "No es igual a",
        "filterIsNullOperator": "Es nulo",
        "filterIsNotNullOperator": "No es nulo",
        "filterIsEmptyOperator": "Está vacío",
        "filterIsNotEmptyOperator": "No está vacío",
        "filterStartsWithOperator": "Comienza con",
        "filterContainsOperator": "Contiene",
        "filterNotContainsOperator": "No contiene",
        "filterEndsWithOperator": "Termina en",
        "filterGteOperator": "Es mayor o igual que",
        "filterGtOperator": "Es mayor que",
        "filterLteOperator": "Es menor o igual que",
        "filterLtOperator": "Es menor o igual que",
        "filterIsTrue": "Sí",
        "filterIsFalse": "No",
        "filterBooleanAll": "(Todas)",
        "filterAfterOrEqualOperator": "Es posterior o igual a",
        "filterAfterOperator": "Es posterior",
        "filterBeforeOperator": "Es anterior",
        "filterBeforeOrEqualOperator": "Es anterior o igual a",
        "filterSubmitButton": "Filtrar",
        "filterClearButton": "Limpiar",
        "filterAndLogic": "Y",
        "filterOrLogic": "O",
        "filterTitle": "Filtros",
        "sortAscending": "Orden ascendente",
        "sortDescending": "Orden descendente"
    },
    "scheduler": {
        "editorValidationRequired": "El campo es obligatorio",
        "editorValidationStart": "La hora de inicio debe ser anterior a la hora de finalización",
        "editorValidationEnd": "La hora de finalización debe ser posterior a la hora de inicio",
        "allEvents": "Todos los eventos",
        "allDay": "todo el día",
        "today": "Hoy",
        "dayViewTitle": "Día",
        "weekViewTitle": "Semana",
        "monthViewTitle": "Mes",
        "workWeekViewTitle": "Semana laboral",
        "timelineViewTitle": "Línea de tiempo",
        "agendaViewTitle": "Agenda",
        "deleteTitle": "Eliminar",
        "previousTitle": "Anterior",
        "nextTitle": "Siguiente",
        "showFullDay": "Mostrar día completo",
        "showWorkDay": "Mostrar horario comercial",
        "editorOccurrence": "Editar ocurrencia actual",
        "editorSeries": "Editar la serie",
        "editorRecurringConfirmation": "¿Desea editar solo este evento o la serie completa?",
        "editorRecurringDialogTitle": "Editar elemento recurrente",
        "editorSave": "Guardar",
        "editorCancel": "Cancelar",
        "editorDelete": "Eliminar",
        "editorTitle": "Evento",
        "editorEventTitle": "Título",
        "editorEventStart": "Inicio",
        "editorEventStartTimeZone": "Zona horaria de inicio",
        "editorEventEnd": "Fin",
        "editorEventEndTimeZone": "Zona horaria final",
        "editorEventAllDay": "Evento de todo el día",
        "editorEventDescription": "Descripción",
        "editorEventSeparateTimeZones": "Finalizar en una zona horaria diferente",
        "editorEventTimeZone": "Especificar zona horaria",
        "recurrenceEditorRepeat": "Repetir",
        "recurrenceEditorDailyInterval": "día (s)",
        "recurrenceEditorDailyRepeatEvery": "Repetir cada",
        "recurrenceEditorWeeklyInterval": "week (s)",
        "recurrenceEditorWeeklyRepeatEvery": "Repetir cada",
        "recurrenceEditorWeeklyRepeatOn": "Repetir en",
        "recurrenceEditorMonthlyDay": "Día",
        "recurrenceEditorMonthlyInterval": "mes (es)",
        "recurrenceEditorMonthlyRepeatEvery": "Repetir cada",
        "recurrenceEditorMonthlyRepeatOn": "Repetir en",
        "recurrenceEditorYearlyOf": "de",
        "recurrenceEditorYearlyRepeatEvery": "Repetir cada",
        "recurrenceEditorYearlyRepeatOn": "Repetir en",
        "recurrenceEditorYearlyInterval": "año (s)",
        "recurrenceEditorFrequenciesDaily": "Diario",
        "recurrenceEditorFrequenciesMonthly": "Monthly",
        "recurrenceEditorFrequenciesNever": "Nunca",
        "recurrenceEditorFrequenciesWeekly": "Semanal",
        "recurrenceEditorFrequenciesYearly": "Anual",
        "recurrenceEditorOffsetPositionsFirst": "Primero",
        "recurrenceEditorOffsetPositionsSecond": "Segundo",
        "recurrenceEditorOffsetPositionsThird": "Tercero",
        "recurrenceEditorOffsetPositionsFourth": "Cuarto",
        "recurrenceEditorOffsetPositionsLast": "Último",
        "recurrenceEditorWeekdaysDay": "Día",
        "recurrenceEditorWeekdaysWeekday": "Weekday",
        "recurrenceEditorWeekdaysWeekendday": "Día de fin de semana",
        "recurrenceEditorEndAfter": "Después",
        "recurrenceEditorEndOccurrence": "ocurrencias",
        "recurrenceEditorEndLabel": "Fin",
        "recurrenceEditorEndNever": "Nunca",
        "recurrenceEditorEndOn": "On",
        "deleteConfirmation": "¿Está seguro de que desea eliminar este evento?",
        "deleteRecurringConfirmation": "¿Desea eliminar solo este evento o la serie completa?",
        "deleteOccurrence": "Eliminar la ocurrencia actual",
        "deleteSeries": "Eliminar la serie",
        "deleteDialogTitle": "Eliminar evento",
        "deleteRecurringDialogTitle": "Eliminar elemento recurrente",
        "dateTitle": "Fecha",
        "timeTitle": "Tiempo",
        "eventTitle": "Evento",
        "noEvents": "sin eventos"
    }
};